import { findUpUntil } from '../../../core/utils/src/dom';
import logger from '../../../core/utils/src/logger';
var findParentComponent = function (startElement, tagNames, validate) {
    if (validate === void 0) { validate = true; }
    var parentNode = findUpUntil(startElement, function (element) { return tagNames.indexOf(element.tagName.toLowerCase()) !== -1; });
    if (!parentNode || !parentNode.tagName) {
        if (validate) {
            logger.error("Component can only exist within " + tagNames.join(' or ') + ".");
        }
        return;
    }
    return parentNode.component;
};
var arrayItemsEqual = function (array1, array2, trackBy) {
    if (array1 === void 0) { array1 = []; }
    if (array2 === void 0) { array2 = []; }
    if (array1 === array2) {
        return true;
    }
    if (array1.length !== array2.length) {
        return false;
    }
    if (trackBy) {
        array1 = array1.map(function (item) { return item[trackBy]; });
        array2 = array2.map(function (item) { return item[trackBy]; });
    }
    return array1.every(function (entry, index) { return entry === array2[index]; });
};
var arrayItemsDifference = function (array1, array2, trackBy) {
    if (array1 === void 0) { array1 = []; }
    if (array2 === void 0) { array2 = []; }
    if (array1 === array2) {
        return [];
    }
    return array1.filter(function (entry1) {
        return !array2.some(function (entry2) {
            if (trackBy) {
                return entry1[trackBy] === entry2[trackBy];
            }
            return entry1 === entry2;
        });
    });
};
var arrayItemsIndexOf = function (container, item, trackBy) {
    if (container === void 0) { container = []; }
    if (trackBy) {
        var index_1 = -1;
        container.some(function (arrayItem, arrayItemIndex) {
            if (arrayItem[trackBy] === item[trackBy]) {
                index_1 = arrayItemIndex;
                return true;
            }
        });
        return index_1;
    }
    return container.indexOf(item);
};
var getPreferencesController = function (element) {
    var preferencesComponent = findParentComponent(element, ['awsui-table-preferences', 'awsui-cards-preferences']);
    return preferencesComponent.__controller;
};
var getCollectionComponent = function (element, validate) {
    if (validate === void 0) { validate = true; }
    return findParentComponent(element, ['awsui-table', 'awsui-cards'], validate);
};
/*
  When table child components are being detached, they are updating table model,
  which is triggering render functions on other child components that are still
  attached because lifecycle still did not reach them. We want to prevent re-rendering
  of these neighbouring elements, when main table component is detached already.
*/
var renderSafely = function (originalRender) {
    return function (m, h) {
        var initialRender = !this.__componentState;
        if (initialRender || !this.__parentComponent || this.__parentComponent.__componentState !== 'detached') {
            return originalRender.call(this, m, h);
        }
        return null;
    };
};
var getComponentSetter = function (componentName) {
    return function (oldValue, newValue) {
        if (oldValue !== newValue) {
            var initializedFeatures = this.__initializedFeatures;
            if (newValue === null) {
                var indexOfFeature = initializedFeatures.indexOf(componentName);
                initializedFeatures.splice(indexOfFeature, 1);
                // When the sub-component is detached, we need to de-initialize the controller before setting the component.
                // If we set the component to null first (remove pagination for example),
                // this would trigger a first re-render (of the non-paginated list of items)
                // which could impact performance.
                this.__checkReadinessAndInitializeController();
                this.__controller.setComponent(componentName, newValue);
            }
            else {
                // When the sub-component is attached, we need to inform the controller first,
                // then initialize it. If we initialize it before setting the component, we would have a first re-render
                // that does not take into account the component. For example, when pagination is attached, we would end up
                // showing the full list of non-paginated items, which is bad.
                this.__controller.setComponent(componentName, newValue);
                initializedFeatures.push(componentName);
                this.__checkReadinessAndInitializeController();
            }
            this.__updateToolsVisibility();
        }
    };
};
var updateController = function (propertyName) {
    return function (oldValue, newValue) {
        if (oldValue !== newValue) {
            this["__" + propertyName + "Ready"] = true;
            this.__controller.setMainComponentData(this.__getData());
            this.__checkReadinessAndInitializeController();
        }
    };
};
var checkReadinessAndInitializeController = function (propertiesNames) {
    return function () {
        var _this = this;
        var featuresReady = this.features.length === 0 || arrayItemsEqual(this.features.sort(), this.__initializedFeatures.sort());
        var propertiesReady = propertiesNames.every(function (propertyName) { return _this["__" + propertyName + "Ready"]; });
        if (this.__componentState === 'attached' && propertiesReady && featuresReady) {
            this.__controller.initialize();
        }
        else {
            this.__controller.deInitialize();
        }
    };
};
var ChangeHandler = /** @class */ (function () {
    function ChangeHandler(method) {
        this.method = method;
        this.blocked = false;
    }
    ChangeHandler.prototype.apply = function (scope, args) {
        if (!this.blocked) {
            this.method.apply(scope, args);
        }
    };
    ChangeHandler.prototype.prevent = function (callback) {
        this.blocked = true;
        callback();
        this.blocked = false;
    };
    return ChangeHandler;
}());
export { findParentComponent, arrayItemsEqual, arrayItemsDifference, arrayItemsIndexOf, getCollectionComponent, getPreferencesController, renderSafely, getComponentSetter, updateController, checkReadinessAndInitializeController, ChangeHandler };
//# sourceMappingURL=utility.js.map